(function () {
	'use strict';

	const modules = [];

	angular.module('DcConnectorModule', modules);
})();
